<template>
  <li :class="[`${classPrefix}__link-item`, activeClass]">
    <router-link :to="`/${item.url}`">
      <div :class="`${classPrefix}__link-icon`"><i class="fa" :class="item.icon"></i></div>
      <p :class="`${classPrefix}__link`">{{ item.title }}</p>
    </router-link>
  </li>
</template>

<script>
  export default {
    name: 'BaseItem',
    components: {},
    props: {
      item: {
        type: Object,
      },
      classPrefix: {
        type: String,
        default: 'links-col',
      },
    },
    computed: {
      routeName() {
        return this.$route.name === 'meeting-agenda' ? 'meeting-agendas' : this.$route.name;
      },
      activeClass() {
        return this.item.url === this.routeName ? 'active' : '';
      },
    },
  };
</script>

